import Cookies from 'js-cookie'

const setObjCookie = (key, data) => Cookies.set(key, JSON.stringify(data))
const getObjCookie = key => {
  try{
    return JSON.parse(Cookies.get(key))
  }catch(e){
    return null;
  }
}

const tokenKey = 'TOKEN_KEY'
export const token = {
  set: data => Cookies.set(tokenKey, data),
  get: () => Cookies.get(tokenKey),
  del: () => Cookies.remove(tokenKey)
}

const UserinfoKey = 'USERINFO_KEY'
export const userinfo = {
  set: data => setObjCookie(UserinfoKey, data),
  get: () => getObjCookie(UserinfoKey),
  del: () => Cookies.remove(UserinfoKey)
}

const collapseKey = 'COLLAPSE_KEY'
export const collapse = {
  set: data => Cookies.set(collapseKey, data ? true : false),
  get: () => {
    let result = Cookies.get(collapseKey);
    return (result === 'true' || result == true) ? true : false;
  },
  del: () => Cookies.remove(collapseKey)
}


// WEBPACK FOOTER //
// ./src/utils/cookies.js